import { InjectionToken } from '@angular/core';
import { ILoanProduct } from '@libs/models/models';

export interface MockProduct extends Partial<ILoanProduct> {
  actionRate?: number;
  upToActionRate?: number;
}

export const AVANS: MockProduct = {
  minTerm: 15,
  maxTerm: 30,
  minAmount: 1000,
  maxAmount: 30000,
  interest: 1,
  issueCommissionRate: 0,
  actionRate: 0.01,
  upToActionRate: 99.99,
  startTerm: 21,
  startAmount: 10000,
  fullTerm: 360,
  termStep: 1,
};

export const FINBAR: MockProduct = {
  minTerm: 15,
  maxTerm: 30,
  minAmount: 1000,
  maxAmount: 30000,
  interest: 1,
  issueCommissionRate: 0,
  actionRate: 0.01,
  startTerm: 21,
  startAmount: 10000,
  fullTerm: 360,
  termStep: 1,
};

export const CREDISEND: MockProduct = {
  minTerm: 15,
  maxTerm: 30,
  minAmount: 1000,
  maxAmount: 30000,
  interest: 1,
  issueCommissionRate: 0,
  actionRate: 0.01,
  startTerm: 21,
  startAmount: 10000,
  fullTerm: 360,
  termStep: 1,
};

export const SUNCREDIT: MockProduct = {
  minTerm: 15,
  maxTerm: 30,
  minAmount: 1000,
  maxAmount: 20000,
  interest: 0.9,
  issueCommissionRate: 10,
  actionRate: 0.01,
  startTerm: 30,
  startAmount: 10000,
  fullTerm: 120,
  termStep: 5,
};

export const STARFIN: MockProduct = {
  minTerm: 15,
  maxTerm: 30,
  minAmount: 1000,
  maxAmount: 20000,
  interest: 0.9,
  issueCommissionRate: 10,
  termStep: 5,
  startAmount: 10000,
  startTerm: 20,
  fullTerm: 120,
};

export const MOCK_PRODUCT_TOKEN = new InjectionToken<MockProduct>('mockProduct');
